module.exports = __webpack_public_path__ + "static/media/grab.6f342f41.png";